import { PrettyProjectPageTypes } from "../components/mainWrapper/MainWrapper";
import { EditProjectPage } from "../components/sidebars/editProjectPage/EditProjectPage";
import { PrettyProjectPage } from "../components/sidebars/prettyProjectPage/PrettyProjectPage";
import { ReportsSidebar } from "../components/sidebars/reportsSidebar/ReportsSidebar";
import Config from "../config/Config";
import { SidebarComponent, SidebarContext } from "./SidebarComponent";

import { PrettyProjectPageLfd } from "../components/sidebars/prettyProjectPage/PrettyProjectPageLfd";
import PrettyProjectPageSpreadingGrounds from "../components/sidebars/prettyProjectPage/PrettyProjectPageSpreadingGrounds";
import { useContext } from "react";
import { useLocation, matchPath } from "react-router";

export interface ISidebarConfig {
    screenSize: number,
    screenDisplayType: string,
    reportPageToShow: string
    setReportPageToShow: Function;
}

export const SidebarConfig = (props: ISidebarConfig) => {
    const {
        sidebarStore,
        sidebarProjectInfoObj,
        setSidebarProjectInfoObj,
        setSidebarVisible,
        sidebarVisible
    } = useContext(SidebarContext);

    const location = useLocation();

    return (
        <div className="home-sidebar-wrapper">
            {
                !!matchPath("/reports/*", location.pathname) &&
                <>
                    <SidebarComponent
                        sidebarName="Reports"
                        screenSize={props.screenSize}
                        screenDisplayType={props.screenDisplayType}>
                        <ReportsSidebar
                            visible={sidebarVisible}
                            setVisible={setSidebarVisible}
                            reportPageToShow={props.reportPageToShow}
                            setReportPageToShow={props.setReportPageToShow} />
                    </SidebarComponent>
                    <SidebarComponent
                        sidebarName="PrettyProjectPage"
                        screenSize={props.screenSize}
                        screenDisplayType={props.screenDisplayType}
                        isSpreadingGrounds={sidebarStore.current.content?.["prettyProjectPageType"] === PrettyProjectPageTypes.SpreadingGround}
                    >
                        {sidebarStore.current.content?.["prettyProjectPageType"] === PrettyProjectPageTypes.BmpGeneral &&
                            <PrettyProjectPage
                                showEditButton={sidebarStore.current.content?.["showEditButton"] ?? false}
                                show24HourCapacity={sidebarStore.current.content?.["show24HourCapacity"]}
                            />
                        }
                        {sidebarStore.current.content?.["prettyProjectPageType"] === PrettyProjectPageTypes.LowFlowDiversion &&
                            <PrettyProjectPageLfd lowFlowDiversion={sidebarStore.current.content?.["lowFlowDiversion"]}
                            />
                        }
                        {sidebarStore.current.content?.["prettyProjectPageType"] === PrettyProjectPageTypes.SpreadingGround &&
                            <PrettyProjectPageSpreadingGrounds
                                spreadingGroundsData={sidebarStore.current.content?.["spreadingGroundsData"]}
                                spreadingGroundsCaptureData={sidebarStore.current.content?.["spreadingGroundsCaptureData"]}
                            />
                        }
                    </SidebarComponent>

                    {sidebarProjectInfoObj &&
                        <SidebarComponent
                            sidebarName="EditProjectPage"
                            screenSize={props.screenSize}
                            screenDisplayType={props.screenDisplayType}
                        >
                            <EditProjectPage
                                project={sidebarProjectInfoObj}
                                setProject={setSidebarProjectInfoObj}
                            />
                        </SidebarComponent>
                    }
                </>
            }

        </div>
    )
}
